import { fetchRepositories } from '../api/digitalVault';
import { parseRepositories } from '../utils';
export default async (props, logger) => {
    const getRepos = await fetchRepositories(logger);
    const { showDeviceDisplayName = false } = props;
    const userRepositories = getRepos?.repositories?.repository;
    return {
        data: [
            ...parseRepositories(userRepositories, showDeviceDisplayName),
        ],
    };
};
